import React, { useMemo } from 'react'
import { useApiFormNodeLibrary, useApiListNodeLibraryCategory } from '../../../../../../api-new/state/content'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { IconCopy } from '../../../../../../shared/icon/icon'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { LibraryMenu } from '../../common/menu/node-actions'
import { FormSimple } from '../../../../../../shared/form-simple/form'
import { FormSimpleHiddenNumber } from '../../../../../../shared/form-simple/form-hidden-number'
import { FormSimpleCategorySelectFilter } from '../../../../../../shared/form-simple/form-category-select-filter'
import { FormSimpleSubmitCreate } from '../../../../../../shared/form-simple/form-submit'
import { FormSimpleText } from '../../../../../../shared/form-simple/form-text'
import { useTransferContext } from '../../../../../../shared/transfer/transfer-provider'
import { useTransferActive, useTransferComplete } from '../../../../../../shared/transfer/hooks/transfer-data'
import { TransferCopyNodeStatus } from '../../../../../../shared/transfer/components/transfer-copy-node-status'
import { useDataContext } from '../data-context'

export const NodeLibraryCopy = ({ parentURL, nodeID }) => {
  const apiFormNodeLibrary = useApiFormNodeLibrary()

  const title = useMemo(() => `copy ${apiFormNodeLibrary.form.name}`, [apiFormNodeLibrary.form.name])

  const handleMatch = async () => await apiFormNodeLibrary.get(nodeID)

  const HeaderMenu = () => <LibraryMenu place="header" url={parentURL} />

  ///////////////

  const { location } = useHistory()

  const dataContext = useDataContext()
  const transferContext = useTransferContext()

  const transferID = useMemo(() => `library-copy-${nodeID}`, [nodeID])

  const transfer = useMemo(() => transferContext.items[transferID] || null, [transferContext.items, transferID])

  const active = useTransferActive(transfer)

  useTransferComplete(transfer, () => dataContext.reload)

  const handleSubmit = async data => {
    if (data.destParentID === -1) {
      data.destParentID = null
    }

    const transfer = transferContext.nodeCopyLibrary(transferID, data.destName, location.pathname)
    transfer.start(data)
  }

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconCopy} text="Copy library" onMatch={handleMatch}>
        <CardFullHeightScrollY title={title} HeaderMenu={HeaderMenu}>
          <FormSimple disabled={active} onSubmit={handleSubmit}>
            <FormSimpleHiddenNumber name="srcNodeID" value={nodeID} required />
            <FormSimpleCategorySelectFilter
              name="destParentID"
              label="category"
              rootName="LIBRARY"
              useApiListCategory={useApiListNodeLibraryCategory}
              required
            />
            <FormSimpleText name="destName" label="name" defaultValue={apiFormNodeLibrary.form.name} required />
            <FormSimpleSubmitCreate text="copy library" backURL={parentURL} />
          </FormSimple>

          <TransferCopyNodeStatus transfer={transfer} />
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
